import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { useBreakpoint } from '@mtsbank/ui-kit'

export const FocusError = () => {
  const { isMobile } = useBreakpoint()

  const { errors, isSubmitting, isValidating } = useFormikContext()

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const keys = Object.keys(errors)

      if (keys.length > 0) {
        const firstErrorFieldName = keys[0]
        const selector = `[name=${firstErrorFieldName}]`
        const errorElement = document.querySelector(selector)

        if (errorElement) {
          if (isMobile) {
            const errorElementRect = errorElement.getBoundingClientRect()

            window.scrollBy({
              top: errorElementRect.top - 100,
              behavior: 'smooth',
            })
          } else {
            errorElement.scrollIntoView({ behavior: 'smooth', block: isMobile ? 'start' : 'center' })
          }

          ;(errorElement as HTMLElement).focus({ preventScroll: true })
        }
      }
    }
  }, [errors, isSubmitting, isValidating])

  return null
}
